import * as React from 'react';
import * as Loadable from 'react-loadable';
import { PageLoadingIndicator } from '@applications/order-tracker/components/page-loading-indicator';

const skeleton = {
    name: 'order-summary-page',
    layout: 'hsec',
    sections: [
        {name: 'breadcrumbs', layout: 'vsec', sections: [{width: '20%', height: 20, align: 'left'}]},
        {name: 'page-titile', layout: 'vsec', align: 'left', sections: [{width: '22%', height: 50, align: 'left'}]},
        {name: 'summary-message', layout: 'vsec', align: 'left', sections: [{width: '50%', height: 20, align: 'left'}]},
        {name: 'search-filter', layout: 'vsec', sections: [{width: '30%', height: 50, align: 'right'}]},
        {name: 'tabs', layout: 'vsec', align: 'left', sections: [{width: '30%', height: 50, align: 'left'}]},
        {name: 'select-download', layout: 'vsec', sections: [{width: '30%', height: 50, align: 'right'}]},
        {name: 'table', layout: 'vsec', align: 'center', sections: [{component: 'table', type: 'basic'}]}
    ]
}

const OrdersSummaryLazy = Loadable({
    loader: () => import(/* webpackChunkName:"orders-summary" */'./index'),
    loading(props) {
        return <PageLoadingIndicator loader="skeleton" screen={skeleton} error={props.error}/>
    }
});

export default OrdersSummaryLazy;
